/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ExternalMCPRemoteHeader,
  ExternalMCPRemoteHeader$inboundSchema,
} from "./externalmcpremoteheader.js";
import {
  ExternalMCPRemoteVariable,
  ExternalMCPRemoteVariable$inboundSchema,
} from "./externalmcpremotevariable.js";

/**
 * Transport type (sse or streamable-http)
 */
export const ExternalMCPRemoteTransportType = {
  Sse: "sse",
  StreamableHttp: "streamable-http",
} as const;
/**
 * Transport type (sse or streamable-http)
 */
export type ExternalMCPRemoteTransportType = OpenEnum<
  typeof ExternalMCPRemoteTransportType
>;

/**
 * A remote endpoint for an MCP server
 */
export type ExternalMCPRemote = {
  /**
   * HTTP headers the MCP client should collect and send when connecting to this remote
   */
  headers?: Array<ExternalMCPRemoteHeader> | undefined;
  /**
   * Transport type (sse or streamable-http)
   */
  transportType: ExternalMCPRemoteTransportType;
  /**
   * URL of the remote endpoint
   */
  url: string;
  /**
   * URL template variables for this remote endpoint
   */
  variables?: { [k: string]: ExternalMCPRemoteVariable } | undefined;
};

/** @internal */
export const ExternalMCPRemoteTransportType$inboundSchema: z.ZodMiniType<
  ExternalMCPRemoteTransportType,
  unknown
> = openEnums.inboundSchema(ExternalMCPRemoteTransportType);

/** @internal */
export const ExternalMCPRemote$inboundSchema: z.ZodMiniType<
  ExternalMCPRemote,
  unknown
> = z.pipe(
  z.object({
    headers: z.optional(z.array(ExternalMCPRemoteHeader$inboundSchema)),
    transport_type: ExternalMCPRemoteTransportType$inboundSchema,
    url: z.string(),
    variables: z.optional(
      z.record(z.string(), ExternalMCPRemoteVariable$inboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "transport_type": "transportType",
    });
  }),
);

export function externalMCPRemoteFromJSON(
  jsonString: string,
): SafeParseResult<ExternalMCPRemote, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ExternalMCPRemote$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ExternalMCPRemote' from JSON`,
  );
}
